import React, { useEffect, useState, useRef } from 'react';
import BallItem from './BallItem';
import styles from './index.less';

/** 相互碰撞的透明小球组件 */
export default ({ callback =()=> {}, }) => {

  const dataSet = [
    {
      title: '测试服务',
      text: 'T-One',
      desc: '业内首个一站式、全场景质量协作平台！提供多 CPU 架构、多 OS 类型、多种复杂环境测试',
      url: 'https://tone.openanolis.cn/',
    },
    {
      title: '安全服务',
      text: 'CVECenter',
      desc: '全流程的漏洞响应能力，CVE 跟踪、预警、修复一条龙！',
      url: 'https://cve-center.openanolis.cn/',
    },
    {
      title: '构建服务',
      text: 'ABS',
      desc: 'ABS 提供全场景构建能力支持，助你快速构建基于 AnolisOS 的软件包和镜像！',
      url: 'https://abs.openanolis.cn/home',
    },
    {
      title: '资源服务',
      text: '龙蜥实验室',
      desc: '缺机器？龙蜥实验室免费用！',
      url: 'https://lab.openanolis.cn/#/apply/home',
    },
    {
      title: '性能调优服务',
      text: 'KeenTune',
      desc: '通过AI算法与专家知识库的有效结合，为OS提供动态和静态协同调优的能力',
      url: 'http://keentune.io/',
    },
    {
      title: 'CI 服务',
      text: 'Anolis Bot',
      desc: '龙蜥通用 CI 服务，自定义接入，是社区产品质量保障的第一道防线！',
      url: 'https://openanolis.cn/sig/SIG-Infra/doc/790371353576161285',
    },
    {
      title: '迁移服务',
      text: 'AOMS',
      desc: '助你快速迁移到 AnolisOS！',
      url: 'https://openanolis.cn/centos-eol#Overall-migration-scheme',
    },
    {
      title: <><div>软硬件</div><div>兼容性服务</div></>,
      text: 'Ancert',
      desc: '硬件兼容性验证与守护，构建完善的硬件生态！',
      url: 'https://eco.openanolis.cn/#/compatibility/hardware',
    },
    {
      title: '镜像服务',
      text: 'Mirror',
      desc: '为用户提供极速、稳定的镜像服务！并提供龙蜥扩展  rsync 能力',
      url: 'https://mirrors.openanolis.cn/ ',
    },
  ];

  const rowStyle = {    
    width: '100%',
    display: 'flex',
  }

  return (
    <div className={styles.ball_container}>
      <div style={{...rowStyle, height: '117px'}}>
        {dataSet.slice(0, 4).map((item, i)=> 
          <BallItem key={i} param={item} index={i+1} />
        )}
      </div>
      <div style={{ ...rowStyle, height: '117px', justifyContent: 'center', padding: '0px 100px', boxSizing: 'border-box'}}>
        {dataSet.slice(4, 7).map((item, i)=>
          <BallItem key={i} param={item} index={i+5} />
        )}
      </div>
      <div style={{ ...rowStyle, height: '117px', justifyContent: 'center', padding: '0px 150px', boxSizing: 'border-box'}}>
        {dataSet.slice(7, 10).map((item, i)=>
          <BallItem key={i} param={item} index={i+8} />
        )}
      </div>

      <div className={styles.bottom_text}>
        <p>devFree</p>
        <p>Just show me the code</p>
      </div>
    </div>
  );
};
